export default "__VITE_ASSET__71f6df4d__"